<youtube-player *ngIf="videoId" [videoId]="videoId" [width]="100" [height]="100" [playerVars]="playerConfig"></youtube-player>
